const PropertyAccess = ['admin', 'agent', 'landlord'];
export default PropertyAccess;
